<template>
  <div>
    <!-- 面包屑导航区域 -->
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{path: '/home'}">首页</el-breadcrumb-item>
      <el-breadcrumb-item>变量管理</el-breadcrumb-item>
      <el-breadcrumb-item>变量归属</el-breadcrumb-item>
    </el-breadcrumb>
    <el-card>
      <!-- 绑定变量归属的表单 -->
      <el-form :model="addForm" ref="addFormRef" label-width="70px">
        <div class="h11">
          <div>
            <h1>归属设置/查询</h1>
          </div>
        </div>
        <div class="form1">
          <el-form-item label="归属名称" prop="AttributionCode">
            <el-select v-model="addForm.AttributionCode" placeholder="请选择" clearable>
              <el-option v-for="item in code" :key="item.value" :label="item.label" :value="item.value"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="选择变量" prop="Variable_Maintenance_ID">
            <el-select v-model="addForm.Variable_Maintenance_ID" placeholder="请选择" clearable>
              <el-option
                v-for="item in VariableList"
                :key="item.ID"
                :label="item.VariableName"
                :value="item.ID"
              ></el-option>
            </el-select>
          </el-form-item>
          <div class="btn1">
            <el-button type="success" @click="addVariableAttr()">绑 定</el-button>
          </div>
          <div class="divider1">
            <el-divider direction="vertical"></el-divider>
          </div>
          <div class="select02">
            <div>
              <el-select v-model="addForm.codeId" placeholder="请选择" clearable>
                <el-option v-for="item in code" :key="item.value" :label="item.label" :value="item.value"></el-option>
              </el-select>
              <el-button type="success" @click="getVariableAttr()" class="aaa">查 询</el-button>
            </div>
          </div>
        </div>
        <el-table id="pdfDom" :data="getVariableAttrList" border stripe>
          <el-table-column type="index"></el-table-column>
          <el-table-column label="ID" prop="Variable_Maintenance_ID"></el-table-column>
          <el-table-column label="变量名称" prop="VariableName"></el-table-column>
          <el-table-column label="变量值" prop="Value"></el-table-column>
          <el-table-column label="操作">
            <template slot-scope="scope">
              <el-button type="danger" icon="el-icon-delete" size="mini" @click="removeVariableAttr(scope)"
                >删除</el-button
              >
            </template>
          </el-table-column>
        </el-table>
      </el-form>
    </el-card>
  </div>
</template>

<script>
export default {
    data () {
        return {
            getTypeList: {
                page: '1',
                limit: '500',
                privateKey: '12a5081e-e354-bada-3952-7a0df30d8849',
                appIdentification: 'wms'
            },
            tableName: 'main_variable_maintenance',
            tableName1: 'Main_Variable_Attribution',
            // 新增归属信息列表
            addForm: {
                Variable_Maintenance_ID: '',
                AttributionCode: '',
                codeId: ''
            },
            // 变量维护信息表
            VariableList: [],
            // 归属代码
            code: [
                {
                    value: 'Alarm',
                    label: '报警'
                },
                {
                    value: 'Inventory',
                    label: '盘点'
                },
                {
                    value: 'IntelligentRobot',
                    label: '智能机器人轴信息'
                },
                {
                    value: 'IntelligentRobot_Run',
                    label: '智能机器人运行信息'
                },
                {
                    value: 'MobileRobot',
                    label: '自主移动机器人'
                },
                {
                    value: 'Assemble_RFID',
                    label: 'RFID监控'
                },
                {
                    value: 'Assemble',
                    label: '智能装配'
                },
                {
                    value: 'Storage',
                    label: '仓储'
                },
                {
                    value: 'VisualDeviceStatus',
                    label: '视觉设备状态'
                },

            ],
            // 查询到的数据
            getVariableAttrList: []
        }
    },
    mounted () {
        this.getVariableList()
    },
    methods: {
        // 调用接口查询变量维护信息
        async getVariableList () {
            let params = new URLSearchParams()
            params.append("page", this.getTypeList.page)
            params.append("limit", this.getTypeList.limit)
            params.append("privateKey", this.getTypeList.privateKey)
            params.append("appIdentification", this.getTypeList.appIdentification)
            params.append("tableName", this.tableName)
            const { data: res } = await this.$http.get('/WMS/GeneralQuery', { params })
            console.log('555454')
            console.log(res.data)
            this.VariableList = res.data
        },
        // 调用接口新增变量归属
        async addVariableAttr () {
            if (!this.addForm.AttributionCode) return this.$message.error('请选择归属名称！')
            if (!this.addForm.Variable_Maintenance_ID) return this.$message.error('请选择变量！')
            let params = new URLSearchParams()
            params.append("Variable_Maintenance_ID", this.addForm.Variable_Maintenance_ID)
            params.append("AttributionCode", this.addForm.AttributionCode)
            params.append("privateKey", this.getTypeList.privateKey)
            params.append("appIdentification", this.getTypeList.appIdentification)
            this.addForm.codeId = this.addForm.AttributionCode
            const { data: res } = await this.$http.post('/WMS/InsertVariableAttribution', params)
            console.log(res)
            if (res == -3) {
                return this.$message.error('该变量已被绑定！')
            }
            if (res !== 1) {
                return this.$message.error('系统异常，绑定失败！')
            }
            this.getVariableAttr()
            this.$message.success('设置成功！')
        },
        // 调用接口查询变量归属表
        async getVariableAttr () {
            let params = new URLSearchParams();
            params.append("ID", this.addForm.codeId)
            params.append("privateKey", this.getTypeList.privateKey)
            params.append("appIdentification", this.getTypeList.appIdentification)
            params.append("page", this.getTypeList.page)
            params.append("limit", this.getTypeList.limit)
            console.log('112' + params)
            const { data: res } = await this.$http.get('/WMS/VariableAttributionID', { params })
            console.log(res)
            console.log(res.data)
            this.getVariableAttrList = res.data
        },
        // 调用接口删除绑定
        async removeVariableAttr (scope) {
            const confirmResult = await this.$confirm(
                '此操作将永久删除该归属信息, 是否继续?',
                '提示',
                {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }
            ).catch(err => err)

            if (confirmResult !== 'confirm') {
                return this.$message.info('已经取消删除！')
            }

            let params = new URLSearchParams();
            params.append("ID", scope.row.ID)
            params.append("privateKey", this.getTypeList.privateKey)
            params.append("appIdentification", this.getTypeList.appIdentification)
            params.append("tableName", this.tableName1)
            const { data: res } = await this.$http.post('/WMS/GeneralDelete', params)
            console.log(res)
            if (res !== 1) {
                return this.$message.error('删除失败')
            }
            this.$message.success('删除成功！')
            this.getVariableAttr()
        },
    }
}
</script>

<style lang="less" scoped>
.form1 {
  display: flex;
}
.btn1 {
  margin-left: 2%;
}
.el-divider--vertical {
  height: 3em;
  margin-left: 200%;
}
.h11 {
  display: flex;
}
.select02 {
  position: relative;
  left: 2%;
}
.aaa {
  position: relative;
  left: 10%;
}
</style>
